export { default } from './FlexItem';
